<template>
    <!--- Navigation --->
    <nav class="section__navigation navigation pfull__12">
        <div class="horizontal-line flex-gap-5">
            <div class="filter-search filter-search_has-filter mr__8 "
                 :class="{'filter-search_active': FilterSearchValue>'','filter-search_focus': FilterSearchFocusin}"
            >
                <button class="filter-search__filter button button_view_icon button_theme_primary button_dropdown-menu"
                        @click="switchShowFilterDropdownMenu"
                >
                    <span class="icon"> <span class="icon__symbol"><SvgIcon class="icon" name="common__slider" /></span> </span>
                </button>
                <ul class="filter-search__choice">
                    <li class="filter-search__choice-item"
                        v-show="routeQueryFilter.type"
                        @click="setUnitsQueryFilterParam('type',false)"
                    >
                        {{FilterSearchTypeText}}
                    </li>
                    <li class="filter-search__choice-item"
                        v-show="routeQueryFilter.mode"
                        @click="setUnitsQueryFilterParam('mode',false)"
                    >
                        {{FilterSearchModesText}}
                    </li>
                    <li class="filter-search__choice-item"
                        v-show="routeQueryFilter.group"
                        @click="setUnitsQueryFilterParam('group',false)"
                    >
                        {{FilterSearchGroupsText}}
                    </li>
                </ul>
                <input class="filter-search__input" type="text" :placeholder="$t('text.Search')" v-model.trim="FilterSearchValue" @focus="FilterSearchFocusin=true" @blur="FilterSearchFocusin=false">
                <button class="filter-search__close button button_view_icon button_theme_primary" @click="FilterSearchValue=''">
                    <span class="icon"> <span class="icon__symbol"><SvgIcon class="icon" name="common__close_sm" /></span> </span>
                </button>
                <div class="filter-search__dropdown-menu dropdown-menu"
                     :class="{'dropdown-menu_open': showFilterDropdownMenu}"
                >
                    <div class="dropdown-menu__wrap">
                        <ul class="dropdown-menu__list list">
                            <li class="dropdown-menu__item item item_has-checkbox" data-type="type"
                                v-for="group in $consts.FilterSearchLists.Shipment.groups"
                                :key="group.id"
                                :class="{'item_active': routeQueryFilter.group === group.id}"
                                @click="setUnitsQueryFilterParam('group', group.id)"
                            >
                                <span class="dropdown-menu__icon icon icon_type_checkbox"> <span class="icon__symbol"><SvgIcon class="icon" name="common__checkbox" /></span> </span>
                                <span class="dropdown-menu__icon icon"> <span class="icon__symbol"><SvgIcon class="icon" :name="group.icon" /></span> </span>
                                <span class="dropdown-menu__item-name">{{$t(group.translate)}} </span>
                            </li>

                            <!-- types -->
                            <li class="dropdown-menu__item item item_type_separator"></li>
                            <li class="dropdown-menu__item item item_has-checkbox" data-type="type"
                                v-for="type in $consts.FilterSearchLists.Shipment.types"
                                :key="type.id"
                                :class="{'item_active': routeQueryFilter.type === type.id}"
                                @click="setUnitsQueryFilterParam('type', type.id)"
                            >
                                <span class="dropdown-menu__icon icon icon_type_checkbox"> <span class="icon__symbol"><SvgIcon class="icon" name="common__checkbox" /></span> </span>
                                <span class="dropdown-menu__icon icon"> <span class="icon__symbol"><SvgIcon class="icon" :name="type.icon" /></span> </span>
                                <span class="dropdown-menu__item-name">{{$t(type.translate)}} </span>
                            </li>

                            <!-- mode -->
                            <li class="dropdown-menu__item item item_type_separator"></li>
                            <li class="dropdown-menu__item item item_has-checkbox" data-type="type"
                                v-for="mode in modes"
                                :key="mode.id"
                                :class="{'item_active': routeQueryFilter.mode === mode.id}"
                                @click="setUnitsQueryFilterParam('mode', mode.id)"
                            >
                                <span class="dropdown-menu__icon icon icon_type_checkbox">
                                    <span class="icon__symbol">
                                        <SvgIcon class="icon" name="common__checkbox" />
                                    </span>
                                </span>
                                <span class="dropdown-menu__icon icon">
                                    <span class="icon__symbol" v-if="mode.icon">
                                        <SvgIcon class="icon" :name="mode.icon"/>
                                    </span>
                                </span>
                                <span class="dropdown-menu__item-name">{{ mode.name }} </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <button class="button button_view_outline button_theme_primary" @click="shipmentEdit">
                + {{ $t('text.Single') }}
            </button>
            <button class="button button_view_outline button_theme_primary" @click="shipmentEditPackage">
                + {{ $t('text.Multiple') }}
            </button>
        </div>
        <TabsControl
            :list="filterStatusList"
            v-model="status"
        />
    </nav>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import TabsControl from "@/components/_base/TabsControl";

    export default {
        name: "ShipmentList_navigation",
        mixins: [],
        inject: [],
        props: {},
        components: {
            TabsControl,
        },
        data() {
            return {
                FilterSearchFocusin: false,
            }
        },
        computed: {
            ...mapGetters([
                "getSubUnitsIdsByIds",
                "getUnitsOnMap",
                "showFilterDropdownMenu",
                "getAppUser",
                "getUnitOrFirstActiveUnitId",
                "getUserStorageKey",
            ]),
            showUnitsOnMap() {
                return this.routeName != this.$consts.routerNames.shipment.all
            },
            modes() {
                return this.$consts?.shipment?.mods?.map(m => ({id: m, icon: m, name: this.$t('Shipment.mod.'+m)}))
            },
            filterStatusList() {
                return [
                    {name: this.$t('Shipment.status.staging'), value: 'staging'},
                    {name: this.$t('Shipment.status.active'), value: ''},
                    {name: this.$t('Shipment.status.completed'), value: 'completed'},
                    {name: this.$t('Shipment.status.unfinished'), value: 'unfinished'},
                ]
            },
            FilterSearchTypeText() {
                let type = this.$consts.FilterSearchLists.Shipment.types.find(s => {
                    return s.id === this.routeQueryFilter.type
                })
                return (type)? this.$t(type.translate) : ''
            },
            FilterSearchGroupsText() {
                let type = this.$consts.FilterSearchLists.Shipment.groups.find(s => {
                    return s.id === this.routeQueryFilter.group
                })
                return (type)? this.$t(type.translate) : ''
            },
            FilterSearchModesText() {
                let mode = this.modes.find(s => {
                    return s.id === this.routeQueryFilter.mode
                })
                return mode ? mode.name : ''
            },
            status: {
                get() {
                    return this.routeQueryFilter.status || ''
                },
                set(vl) {
                    this.setUnitsQueryFilterParam('status', vl)
                }
            },
            FilterSearchValue: {
                get(){
                    // console.log('FilterSearchValue.get', this.filter.name)
                    return this.routeQueryFilter.name
                },
                set(value){
                    let filter = {...this.routeQueryFilter}
                    filter.name = value
                    this.setRoute.shipmentFilter(this.$route, this.$router, filter)
                },
            },
        },
        methods: {
            ...mapActions([
                "setMapBoundsByUnits",
                "setUnitsShowOnMap",
            ]),
            ...mapMutations([
                "switchShowFilterDropdownMenu",
                "setShowFilterDropdownMenu",
                "setAllUnitsShowOnMap",
            ]),
            shipmentEdit() {
                this.setRoute.shipmentEditView(this.$route, this.$router, -1)
            },
            shipmentEditPackage() {
                this.setRoute.shipmentEditPackage(this.$route, this.$router, -1)
            },
            setUnitsQueryFilterParam(param, value) {
                let filter = {...this.routeQueryFilter}
                if(value && filter[param] != value) {
                    filter[param] = value
                } else {
                    delete filter[param];
                }
                this.setRoute.shipmentFilter(this.$route, this.$router, filter)
            },
        },
        updated() {
            //console.log(`UnitsList_navigation updated`)
        },
        mounted() {
        },
    }
</script>

<style scoped>

</style>